/* global axios */
import ApiClient from './ApiClient';

class MonitoringAPI extends ApiClient {
  constructor() {
    super('monitoring', { accountScoped: true, apiVersion: 'v2' });
  }

  // GK-HUB: Team-based scoping (supervisor auto-scoped on backend via team_ids)
  get({ inboxId, teamId } = {}) {
    return axios.get(this.url, {
      params: {
        inbox_id: inboxId,
        team_id: teamId,
      },
    });
  }

  // GK-HUB (#109): viewer presence — registra que o painel de monitoramento está aberto
  // (MonitoringViewerTracker no backend). Alimenta o gate de enqueue do MonitoringBroadcastJob:
  // sem viewer → 0 emissão; com viewer → realtime volta. Ver #106.
  viewerHeartbeat() {
    return axios.post(`${this.url}/viewer_heartbeat`);
  }

  viewerLeave() {
    return axios.post(`${this.url}/viewer_leave`);
  }
}

export default new MonitoringAPI();
